import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c69001a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "上传文件", -1))
const _hoisted_7 = {
  key: 2,
  class: "ant-image-mask"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "eye",
  class: "anticon anticon-eye"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "eye",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "64 64 896 896"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" })
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预览", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 下载模版 ")

import { ref, computed } from "vue";
import axios from "axios";
import type { UploadProps, UploadChangeParam } from "ant-design-vue";
import { message } from "ant-design-vue";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons-vue";
import { downloadFile } from "@/utils/download";

import { previewFile } from "@/api/index";
import { withDefaults } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    value: null,
    downloadLink: null,
    disable: { type: Boolean, default: false },
    disableClose: { type: Boolean, default: false },
    fileType: { default: "" }
  },
  emits: ["upload"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { value: string, downloadLink?: {
      filename: string;
      fileKey: string;
    }, disable: boolean, disableClose: boolean, fileType: string }


const loading = ref<boolean>(false);
const headers = {
  Authorization: sessionStorage.getItem("token"),
};


const handleDownload = () => {
  const { filename = "", fileKey = "" } = props.downloadLink || {};
  downloadFile(filename, fileKey);
};

const handleChange = (info: UploadChangeParam) => {
  if (info.file.status === "uploading") {
    loading.value = true;
    return;
  }
  if (info.file.status === "done") {
    loading.value = false;
    const { Data = [], Success, Message } = info.file.response;
    if (Success) {
      $emit("upload", { ...Data[0], AccessoryType: props.fileType });
    } else {
      message.error(Message || "上传失败");
    }
  }
  if (info.file.status === "error") {
    loading.value = false;
    message.error("上传失败");
  }
};

const resetField = () => {
  $emit("upload", null);
};

const fileClick = async (value: string) => {
  window.open(value);
  // const { Data } = await previewFile(props.fileType || "");
  // if (Data) {
  //   window.open(Data);
  // }
};
// 获取文件类型
const getFileType = (imgObj: string) => {
  // 1: 图片  2： paf  3： word  4: txt  5 zip 6 excel 7 ppt 8 other
  let val = 1;
  const SrcArr = imgObj.split(".");
  if (SrcArr.includes("pdf") || SrcArr.includes("PDF")) {
    val = 2;
  } else if (SrcArr.includes("doc") || SrcArr.includes("docx")) {
    val = 3;
  } else if (SrcArr.includes("txt")) {
    val = 4;
  } else if (SrcArr.includes("zip") || SrcArr.includes("rar")) {
    val = 5;
  } else if (
    SrcArr.includes("excel") ||
    SrcArr.includes("xlsx") ||
    SrcArr.includes("xls")
  ) {
    val = 6;
  } else if (SrcArr.includes("ppt")) {
    val = 7;
  } else if (
    SrcArr.includes("jpg") ||
    SrcArr.includes("png") ||
    SrcArr.includes("jpeg") ||
    SrcArr.includes("gif") ||
    SrcArr.includes("JPG") ||
    SrcArr.includes("PNG") ||
    SrcArr.includes("JPEG") ||
    SrcArr.includes("GIF")
  ) {
    val = 1;
  } else {
    val = 8;
  }
  return val;
};

const beforeUpload = (file: UploadProps["fileList"][number]) => {
  //todo: excel表格兼容
  const type = getFileType(file.name);
  const isPermit =
    type == 1 || type == 2 || type == 3 || type == 5 || type == 6 || type == 8;
  // ".pdf,image/png, image/jpeg, image/gif, image/jpg, .zip,.doc,.docx,.xls";
  if (!isPermit) {
    message.error("支持上传图片、pdf、Excel、word、.xls、压缩包!");
  }
  const isLt20M = file.size / 1024 / 1024 < 45;
  if (!isLt20M) {
    message.error("上传不得超过45M");
  }
  return isLt20M && isPermit;
};

return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_upload = _resolveComponent("a-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(__props.value ? 'hover-uploader' : '')
        }, [
          (!__props.disableClose)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "close",
                onClick: resetField
              }))
            : _createCommentVNode("", true),
          (getFileType(__props.value) === 1)
            ? (_openBlock(), _createBlock(_component_a_image, {
                key: 1,
                style: {"width":"104px","height":"104px","z-index":"10","padding":"0"},
                src: __props.value
              }, null, 8, ["src"]))
            : (getFileType(__props.value) === 2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  src: require('../assets/imgs/Common/pdf_1.png'),
                  alt: "",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (fileClick(__props.value)), ["stop"]))
                }, null, 8, _hoisted_2))
              : (getFileType(__props.value) === 3)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 3,
                    src: require('../assets/imgs/Common/word_1.png'),
                    alt: "",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (fileClick(__props.value)), ["stop"]))
                  }, null, 8, _hoisted_3))
                : (getFileType(__props.value) === 5)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 4,
                      src: require('../assets/imgs/Common/zip_1.png'),
                      alt: "",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (fileClick(__props.value)), ["stop"]))
                    }, null, 8, _hoisted_4))
                  : (getFileType(__props.value) === 6)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 5,
                        src: require('../assets/imgs/Common/excel_1.png'),
                        alt: "",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (fileClick(__props.value)), ["stop"]))
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true)
        ], 2))
      : (_openBlock(), _createBlock(_component_a_upload, {
          key: 1,
          name: "value",
          "list-type": "picture-card",
          class: "avatar-uploader",
          action: `${_unref(axios).defaults.baseURL}api/file/uploadFile`,
          headers: headers,
          "before-upload": beforeUpload,
          onChange: handleChange,
          "show-upload-list": false,
          disabled: __props.disable
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (loading.value)
                ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                : (_openBlock(), _createBlock(_unref(PlusOutlined), { key: 1 })),
              _hoisted_6
            ])
          ]),
          _: 1
        }, 8, ["action", "disabled"])),
    (__props.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "ant-image-mask-info",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (fileClick(__props.value)), ["stop"]))
          }, _hoisted_10)
        ]))
      : _createCommentVNode("", true),
    (__props.downloadLink)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "download",
          onClick: handleDownload
        }, [
          _createElementVNode("img", {
            width: "22px",
            src: require('../assets/imgs/Upload/download.png')
          }, null, 8, _hoisted_11),
          _hoisted_12
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})